import React from "react";
import { Typography } from "@mui/material";
import "./Newhome.css";
import { useLanguage } from "../../../utils/languageContext";

const ProgramSection = () => {
  const { t } = useLanguage();
  return (
    <div className="programesnew-section">
      <div className="newprogram_imgage">
        <img
          src="/images/Mainsum.png"
          alt="Integrated Programs"
          className="program-image"
        />
        <Typography className="program-titlefull overlay-text">
          {t("homepage.programSection.title")}{" "}
          <span className="bgcolorspan">
            {t("homepage.programSection.titleHighlight")}
          </span>
        </Typography>
      </div>
    </div>
  );
};

export default ProgramSection;